module.exports = __webpack_public_path__ + "static/media/404.d5267d84.png";